'use client'
import type { ExpectedBlockType, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { filterByBlockType } from '@/services/storyblok/Storyblok.helpers'
import { storyblokEditable } from '@storyblok/react'
import type { ProductPillowBlockProps } from './ProductPillowBlock'
import { ProductPillowBlock } from './ProductPillowBlock'
import { scrollerContent, scrollerItem, scrollerPlatter, wrapper } from './ProductPillowsBlock.css'

export type ProductPillowsBlockProps = SbBaseBlockProps<{
  items: ExpectedBlockType<ProductPillowBlockProps>
  priority?: boolean
}>

export const ProductPillowsBlock = ({ blok }: ProductPillowsBlockProps) => {
  const items = filterByBlockType(blok.items, ProductPillowBlock.blockName)
  console.log('🚀 ~ ProductPillowsBlock ~ OUAGDISFGDIS:', blok.priority)
  return (
    <div className={wrapper} {...storyblokEditable(blok)}>
      <div className={scrollerContent}>
        <div className={scrollerPlatter} role="list">
          {items.map((nestedBlock) => (
            <div key={nestedBlock._uid} className={scrollerItem} role="listitem">
              <ProductPillowBlock blok={nestedBlock} imagePriority={blok.priority} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

ProductPillowsBlock.blockName = 'productPillows'
